import axios from "axios";
import { FAQ_API } from "./config";

const authHeaders = (token) => ({ authorization: `Bearer ${token}` });

// FastAPI expects repeated keys for array query params (tags=a&tags=b), not
// axios's default tags[]=a&tags[]=b bracket notation — build the query string
// manually so array filters (tags) are actually honored server-side.
export const listFaq = (token, filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (key === "tags" && Array.isArray(value)) {
      value.forEach((tag) => params.append("tags", tag));
    } else if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  return axios
    .get(`${FAQ_API}/faq?${params.toString()}`, {
      headers: authHeaders(token),
    })
    .then((res) => res.data);
};

export const getFaqStats = (token) =>
  axios
    .get(`${FAQ_API}/faq/stats`, { headers: authHeaders(token) })
    .then((res) => res.data);

export const getAllTags = (token) =>
  axios
    .get(`${FAQ_API}/faq/tags`, { headers: authHeaders(token) })
    .then((res) => res.data);

export const createFaq = (token, body) =>
  axios
    .post(`${FAQ_API}/faq`, body, { headers: authHeaders(token) })
    .then((res) => res.data);

export const updateFaq = (token, identifier, body) =>
  axios
    .put(`${FAQ_API}/faq/${identifier}`, body, { headers: authHeaders(token) })
    .then((res) => res.data);

export const deleteFaq = (token, identifier) =>
  axios
    .delete(`${FAQ_API}/faq/${identifier}`, { headers: authHeaders(token) })
    .then((res) => res.data);

export const batchUpdateStatus = (token, questionIds, status) =>
  axios
    .post(
      `${FAQ_API}/faq/batch/status`,
      { question_ids: questionIds, status },
      { headers: authHeaders(token) },
    )
    .then((res) => res.data);

export const batchDeleteFaq = (token, questionIds) =>
  axios
    .post(
      `${FAQ_API}/faq/batch/delete`,
      { question_ids: questionIds },
      { headers: authHeaders(token) },
    )
    .then((res) => res.data);

export const batchApproveReview = (token, logIds) =>
  axios
    .post(
      `${FAQ_API}/review/batch/approve`,
      { log_ids: logIds },
      { headers: authHeaders(token) },
    )
    .then((res) => res.data);

export const batchRejectReview = (token, logIds) =>
  axios
    .post(
      `${FAQ_API}/review/batch/reject`,
      { log_ids: logIds },
      { headers: authHeaders(token) },
    )
    .then((res) => res.data);

export const listCategories = (token) =>
  axios
    .get(`${FAQ_API}/categories`, { headers: authHeaders(token) })
    .then((res) => res.data);

export const listFaqVersions = (token, identifier) =>
  axios
    .get(`${FAQ_API}/faq/${identifier}/versions`, {
      headers: authHeaders(token),
    })
    .then((res) => res.data);

export const rollbackFaq = (token, identifier, versionNum) =>
  axios
    .post(
      `${FAQ_API}/faq/${identifier}/rollback/${versionNum}`,
      {},
      { headers: authHeaders(token) },
    )
    .then((res) => res.data);
